export default __webpack_public_path__ + "static/media/logo.80cda1e3.svg";